import React, { useState } from 'react';
import { Plus, Edit2, Power } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Table } from '../components/ui/Table';
import { Modal } from '../components/ui/Modal';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
import { Trainer } from '../types';
export function TrainersPage() {
  const [trainers, setTrainers] = useState<Trainer[]>([{
    id: '1',
    name: 'Dr. Ahmed Rahman',
    designation: 'Senior Trainer',
    phone: '01712345678',
    email: 'ahmed@example.com',
    organization: 'ekseba',
    status: 'active'
  }, {
    id: '2',
    name: 'Fatima Begum',
    designation: 'Training Coordinator',
    phone: '01812345678',
    email: 'fatima@example.com',
    organization: 'ekseba',
    status: 'active'
  }]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTrainer, setEditingTrainer] = useState<Trainer | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    phone: '',
    email: '',
    organization: ''
  });
  const handleAdd = () => {
    setEditingTrainer(null);
    setFormData({
      name: '',
      designation: '',
      phone: '',
      email: '',
      organization: ''
    });
    setIsModalOpen(true);
  };
  const handleEdit = (trainer: Trainer) => {
    setEditingTrainer(trainer);
    setFormData({
      name: trainer.name,
      designation: trainer.designation,
      phone: trainer.phone,
      email: trainer.email,
      organization: trainer.organization
    });
    setIsModalOpen(true);
  };
  const handleSave = () => {
    if (editingTrainer) {
      setTrainers(trainers.map(t => t.id === editingTrainer.id ? {
        ...t,
        ...formData
      } : t));
    } else {
      const newTrainer: Trainer = {
        id: Date.now().toString(),
        ...formData,
        status: 'active'
      };
      setTrainers([...trainers, newTrainer]);
    }
    setIsModalOpen(false);
  };
  const toggleStatus = (id: string) => {
    setTrainers(trainers.map(t => t.id === id ? {
      ...t,
      status: t.status === 'active' ? 'inactive' : 'active'
    } : t));
  };
  const columns = [{
    key: 'name',
    header: 'Name'
  }, {
    key: 'designation',
    header: 'Designation'
  }, {
    key: 'phone',
    header: 'Phone'
  }, {
    key: 'email',
    header: 'Email'
  }, {
    key: 'organization',
    header: 'Organization'
  }, {
    key: 'status',
    header: 'Status',
    render: (value: string) => <Badge variant={value === 'active' ? 'success' : 'default'} data-id="element-409">
          {value === 'active' ? 'Active' : 'Inactive'}
        </Badge>
  }, {
    key: 'actions',
    header: 'Actions',
    render: (_: any, row: Trainer) => <div className="flex gap-2" data-id="element-410">
          <button onClick={() => handleEdit(row)} className="p-1 text-blue-600 hover:text-blue-800" title="Edit" data-id="element-411">
            <Edit2 className="w-4 h-4" data-id="element-412" />
          </button>
          <button onClick={() => toggleStatus(row.id)} className="p-1 text-gray-600 hover:text-gray-800" title="Toggle Status" data-id="element-413">
            <Power className="w-4 h-4" data-id="element-414" />
          </button>
        </div>
  }];
  return <div className="space-y-6" data-id="element-415">
      <div className="flex justify-between items-center" data-id="element-416">
        <div data-id="element-417">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-418">
            Trainers Management
          </h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-419">
            Manage trainers and facilitators
          </p>
        </div>
        <Button onClick={handleAdd} data-id="element-420">
          <Plus className="w-4 h-4 mr-2" data-id="element-421" />
          Add Trainer
        </Button>
      </div>

      <Table columns={columns} data={trainers} emptyMessage="No trainers added yet" data-id="element-422" />

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={editingTrainer ? 'Edit Trainer' : 'Add New Trainer'} footer={<>
            <Button variant="secondary" onClick={() => setIsModalOpen(false)} data-id="element-424">
              Cancel
            </Button>
            <Button onClick={handleSave} data-id="element-425">
              {editingTrainer ? 'Update' : 'Add'} Trainer
            </Button>
          </>} data-id="element-423">
        <div className="space-y-4" data-id="element-426">
          <Input label="Name" value={formData.name} onChange={e => setFormData({
          ...formData,
          name: e.target.value
        })} required data-id="element-427" />
          <Input label="Designation" value={formData.designation} onChange={e => setFormData({
          ...formData,
          designation: e.target.value
        })} required data-id="element-428" />
          <Input label="Phone" value={formData.phone} onChange={e => setFormData({
          ...formData,
          phone: e.target.value
        })} required data-id="element-429" />
          <Input label="Email" type="email" value={formData.email} onChange={e => setFormData({
          ...formData,
          email: e.target.value
        })} required data-id="element-430" />
          <Input label="Organization" value={formData.organization} onChange={e => setFormData({
          ...formData,
          organization: e.target.value
        })} required data-id="element-431" />
        </div>
      </Modal>
    </div>;
}